import { Group, Layout, Page } from "@/comn/components";
import { useNavigate, useParams } from "react-router-dom";
import { useFetch, useForm, useModal, usePage, useResource, useStore, useToast } from "@/comn/hooks";
import { APIS, URLS, SF_SCTN_INFO } from "@/tra/tancis/ptli/usr/sctn/services/PtliSctnService";
import { useEffect } from "react";

/*
 * Section information details
 * !== 섹션 정보 상세 ==!
 */
export const PTLI0918003Q = () => {
    useResource({
        defaultSchema: [
            { area: "comnCd", comnCd: "COM0011" },
            { area: "comnCd", comnCd: "COM0024" },
            { area: "comnCd", comnCd: "COM0025" },
        ],
    });

    const { pgeUid, menuId } = usePage({
        auth: ["auth_ptli0015", "auth_ptlianyADM"],
    });
    const navigate = useNavigate();
    const { pgeStore } = useStore({ pgeUid: pgeUid });
    const modal = useModal();
    const toast = useToast();
    const { cstmOrgzCd } = useParams(); // Key Information of this Component Router !== 라우터에 정의된 키정보 ==!

    const form = {
        sctnInfo: useForm({
            defaultSchema: SF_SCTN_INFO,
        }),
    };

    const fetch = {
        getSctnInfo: useFetch({
            api: () => APIS.getSctnInfo(cstmOrgzCd),
            enabled: !!cstmOrgzCd,
            onSuccess: (data) => {
                // 데이터가 없을 경우
                if (!data.sctnInfo.content) {
                    modal.openModal({ content: "msg.com.00034" }); // No data found. !== 해당 데이터가 없습니다. ==!

                    navigate(`${URLS.ptli0918001q}?menuId=${menuId}`);
                    return;
                }
                form.sctnInfo.setValues(data.sctnInfo.content);
            },
            onError: () => toast.showToast({ type: "error", content: "msg.com.00018" }), // An error occurred. !== 에러가 발생했습니다! ==!
            showToast: true,
        }),
        deleteSctnInfo: useFetch({
            api: (cstmOrgzCd) => APIS.deleteSctnInfo(cstmOrgzCd),
            onSuccess: () => {
                modal.openModal({
                    content: "msg.com.00060",
                    onCancel: () => {
                        navigate(URLS.ptli0918001q);
                    },
                });
            },
            onError: () => toast.showToast({ type: "error", content: "msg.com.00018" }), // An error occurred. !== 에러가 발생했습니다! ==!
            showToast: true,
        }),
    };

    const handler = {
        onListBtnClick: () => {
            navigate(`${URLS.ptli0918001q}?menuId=${menuId}`);
        },
        onEditBtnClick: () => {
            navigate(`${URLS.ptli0918004s}/${cstmOrgzCd}?menuId=${menuId}`);
        },
        deleteSctnInfo: () => {
            modal.openModal({
                content: "msg.com.00049",
                onConfirm: () => {
                    fetch.deleteSctnInfo.fetch(cstmOrgzCd);
                },
            });
        },
    };

    useEffect(() => {
        fetch.getSctnInfo.fetch();
        form.sctnInfo.setEditable(false);
    }, []);

    return (
        <Page>
            <Group>
                <Group.Body>
                    <Group.Section>
                        <Group.Row>
                            <Group.Control {...form.sctnInfo.schema.cstmOrgzTpCd} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.sctnInfo.schema.cstmOrgzCd} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.sctnInfo.schema.cstmOrgzNmTz} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.sctnInfo.schema.cstmOrgzNmEn} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.sctnInfo.schema.cstmOrgzNmKo} />
                        </Group.Row>
                    </Group.Section>
                    <Group.Section></Group.Section>
                </Group.Body>
            </Group>
            <Layout>
                <Layout.Left>
                    <Layout.Button role={"list"} onClick={handler.onListBtnClick} />
                </Layout.Left>
                <Layout.Right>
                    <Layout.Button role="edit" onClick={handler.onEditBtnClick} />
                    <Layout.Button
                        role="delete"
                        onClick={() => {
                            handler.deleteSctnInfo();
                        }}
                    />
                </Layout.Right>
            </Layout>
        </Page>
    );
};
